import { connect } from 'react-redux';
import IndicatorsDashbordActivity from '../../components/dashboard/indicatorsDashbord/Activity/IndicatorsDashbordActivity';

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(IndicatorsDashbordActivity);
